import React from "react";
import "../HTMate/HTMate.scss";

const Cookies = () => {
  return (
    <div className="textitem">
      <h3>Hlthtek.com Cookies Policy</h3>
      <p>
        <strong>Last Updated:</strong> 1st June 2024
      </p>

      <p>Welcome to Hlthtek.com!</p>

      <p>
        This Cookies Policy explains how we use cookies and similar technologies
        on our website ("Platform"). By using our Platform, you consent to the
        use of cookies as described in this policy.
      </p>

      <div className="textitem">
        <h5>What are Cookies?</h5>
        <p>
          Cookies are small text files that are placed on your computer or
          mobile device when you visit a website. They are widely used by
          websites to enhance user experience by remembering your preferences
          and providing personalized content.
        </p>
      </div>

      <div className="textitem">
        <h5>How We Use Cookies:</h5>
        <ul>
          <li>
            <strong>Essential Cookies:</strong> These cookies are necessary for
            the website to function properly and enable you to navigate and use
            its features.
          </li>
          <li>
            <strong>Performance Cookies:</strong> These cookies collect
            information about how you use the website, such as which pages you
            visit most often. This helps us improve the performance of our
            Platform.
          </li>
          <li>
            <strong>Functionality Cookies:</strong> These cookies allow the
            website to remember your preferences and choices, such as your
            username, language, or region.
          </li>
          <li>
            <strong>Targeting Cookies:</strong> These cookies are used to
            deliver advertisements that are more relevant to you and your
            interests. They may also limit the number of times you see an ad and
            help measure the effectiveness of advertising campaigns.
          </li>
        </ul>
      </div>

      <div className="textitem">
        <h5>Managing Cookies:</h5>
        <p>
          You can control and manage cookies through your browser settings. Most
          browsers allow you to refuse cookies or delete them from your device.
          However, please note that disabling cookies may affect the
          functionality and performance of our Platform.
        </p>
        <p>
          For more information on how to manage cookies, please refer to your
          browser’s help documentation or visit the following links:
        </p>
        <ul>
          <li>
            <a
              href="https://www.allaboutcookies.org/manage-cookies"
              target="_blank"
              rel="noopener noreferrer"
            >
              All About Cookies
            </a>
          </li>
          <li>
            <a
              href="https://www.aboutcookies.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              About Cookies
            </a>
          </li>
        </ul>
      </div>

      <div className="textitem">
        <h5>Changes to this Policy:</h5>
        <p>
          We may update this Cookies Policy from time to time. Any changes will
          be posted on the Platform with the updated date. You are responsible
          for reviewing the Policy periodically.
        </p>
      </div>

      <div className="textitem">
        <h5>Contact Us:</h5>
        <p>
          If you have any questions about this Cookies Policy, please contact us
          at
          <a href="mailto:contactus@hlthtek.com">contactus@hlthtek.com</a>.
        </p>
      </div>

      <p>
        <strong>
          By accessing and using the Hlthtek.com platform, you agree to this
          Cookies Policy.
        </strong>
      </p>
    </div>
  );
};

export default Cookies;
